import { post } from "./base";

export async function getImsData(accessToken, data) {
  const result = await post("ag_imsdata/GetImsData", { jsonBody: { accessToken, data } });

  return result;
}

export const transformData = (rawData) => {
  let jsonData;

  try {
    // jsonData = JSON.parse(rawData);
    jsonData = rawData;
  } catch (error) {
    console.error("Errore nel parsing del JSON:", error);
    return [];
  }

  const periodo = jsonData.date_start?.slice(0, 7);
  if (!periodo) {
    console.warn("date_start mancante nei dati", jsonData);
    return [];
  }

  const base = {
    user_id: jsonData.user_id,
    periodo,
  };

  const items = jsonData[0];
  if (!Array.isArray(items)) {
    console.warn("Il campo dati [0] non è un array", items);
    return [];
  }

  return items.map((row) => ({
    ...base,
    sku: row.sku,
    prov: row.prov,
    regione: row.regione,
    linea: row.linea,
    qty: isNaN(parseInt(row.qty, 10)) ? 0 : parseInt(row.qty, 10),
    price: isNaN(parseFloat(row.price)) ? 0.00 : parseFloat(row.price),
    fatturato: isNaN(parseFloat(row.fatturato)) ? 0.00 : parseFloat(row.fatturato),
  }));
};

export const transformData_old = (rawData) => {
  // console.log("Raw data received for transformation:", rawData);
  const jsonData = JSON.parse(rawData);
  const base = {
    user_id: jsonData.user_id,
    date_start: jsonData.date_start,
    date_end: jsonData.date_end,
    ref_date_start: jsonData.ref_date_start,
    ref_date_end: jsonData.ref_date_end,
  };

  const items = jsonData[0].map((row) => ({
    ...base,
    sku: row.sku,
    prov: row.prov,
    regione: row.regione,
    qty: parseInt(row.qty, 10),
    qty_ref: parseInt(row.qty_ref, 10),
    diff: parseInt(row.qty, 10) - parseInt(row.qty_ref, 10),
    trend: parseInt(row.qty, 10) >= parseInt(row.qty_ref, 10) ? "positive" : "negative",
  }));

  return items;
};
